import Vue from 'vue'
import App from './App.vue'
import routes from './router'
import store from './store';
import ElementUI from 'element-ui';
import Vuex from 'vuex';
import I18n from './lang/i18n.js';
import 'element-ui/lib/theme-chalk/index.css';
import './common/css/element-variables.scss'

// css样式配置
import '@/common/css/common.css';
import '@/common/css/root.scss';
import '@/common/css/base.css';
import '@/common/css/base.scss';

Vue.config.productionTip = false
Vue.use(ElementUI, {
  i18n: (key, value) => I18n.i18n.t(key, value),
})
Vue.use(Vuex);
// router路由配置
let router = null;
let instance = null;
if ( window.__POWERED_BY_QIANKUN__ ) {
  __webpack_public_path__ = window.__INJECTED_PUBLIC_PATH_BY_QIANKUN__
}

function render(props = {}) {
  const { container } = props
  router = routes,
  instance = new Vue({
    i18n:I18n.i18n,
    router,
    store,
    render: h => h(App),
  }).$mount( container ? container.querySelector( '#app' ) : '#app' )
}

if (!window.__POWERED_BY_QIANKUN__) {
  render()
}

export function bootstrap(props) {
  return new Promise( function ( resolve ) {
    resolve()
  } )
}

export function mount(props) {
  return new Promise( function ( resolve ) {
    render( props )
    resolve()
  } )
}

export function unmount(props) {
  return new Promise( function ( resolve ) {
    instance.$destroy()
    instance = null
    router = null
    resolve()
  } )
}

// 监听全局分辨率
const onResize = () => {
  let dist = document.body.clientWidth;
  let assw = null;
  if (dist > 1919) {
    assw = 1;
  }
  if (dist < 1919 && dist > 1535) {
    assw = 1.24;
  }
  if (dist < 1535) {
    assw = 1.5;
  }
  Vue.prototype.$SCREENWIDTH = assw;
};
window.addEventListener('resize', () => {
  onResize();
});
window.onresize = onResize;
onResize();

// const windowDevice = window.devicePixelRatio;
// if (windowDevice === 1.5) {
//   document.body.style.zoom = 100 / 150;
// } else if (windowDevice === 1.25) {
//   document.body.style.zoom = 100 / 125;
// } else {
//   document.body.style.zoom = 1;
// }